import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"


export const isLoadingUserSettingWebSupplierGroupData = signal(true)
export const userSettingWebSupplierGroupData = signal([])
export const userSettingsWebSupplierGroupFormData = signal({})

export const isOpenUserSettingsWebSupplierGroupDrawer = computed(() => !isEmpty(userSettingsWebSupplierGroupFormData.value))
export const isEditUserSettingsWebSupplierGroupDrawer = computed(() => userSettingsWebSupplierGroupFormData.value?.id !== null)

export const clearUserSettingWebSupplierGroupSignals = () => batch(() => {
	isLoadingUserSettingWebSupplierGroupData.value = true
	userSettingWebSupplierGroupData.value = []
	userSettingsWebSupplierGroupFormData.value = {}
})